import ItemModalSFC from "./ItemModal.vue";
export const ItemModal = ItemModalSFC;
